import { Form } from 'semantic-ui-react';
import React from 'react';
import RichTextEditor from '../../../../RichTextEditor';

const Details = ({ obj, language, onChange }) => {
  return (
    <div>
      <Form.Field>
        <Form.Input
          placeholder="Titre du bloc"
          id="title"
          fluid
          label="Titre du bloc"
          value={
            obj.translations[language.code] &&
            obj.translations[language.code].title
          }
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
      <Form.Field>
        <RichTextEditor
          id="description"
          value={
            obj.translations[language.code] &&
            obj.translations[language.code].description
          }
          onChange={(e) => onChange(e, language.code)}
        />
      </Form.Field>
    </div>
  );
};

export default Details;



// WEBPACK FOOTER //
// ./src/components/form/pageBuilder/blocks/image_gallery/details.js